import { Checkbox, Collapse } from 'antd';
import { TemplateConfig } from '../../../Templar/RenderPdfPrescription';
import { AntTooltip } from '../../../components/common/AntTooltip';
const { Panel } = Collapse;

const OpthalAllTables: React.FC<{
    rxConfig: TemplateConfig | undefined;
    saveRxConfigInState: (rxObj: TemplateConfig) => void;
    sectionName?: string;
}> = ({ rxConfig, saveRxConfigInState, sectionName }) => {
    return (
        <Collapse
            expandIcon={() => (
                <div className="rounded-4 min-w-26 h-26 flex items-center justify-center bg-accent-dark-green">
                    <div className="w-full h-full flex items-center justify-center">
                        <svg
                            width="13"
                            height="13"
                            viewBox="0 0 13 13"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M10.8221 6.5C10.8221 4.90625 9.95488 3.42969 8.57207 2.60938C7.16582 1.8125 5.45488 1.8125 4.07207 2.60938C2.66582 3.42969 1.82207 4.90625 1.82207 6.5C1.82207 8.11719 2.66582 9.59375 4.07207 10.4141C5.45488 11.2109 7.16582 11.2109 8.57207 10.4141C9.95488 9.59375 10.8221 8.11719 10.8221 6.5ZM0.322068 6.5C0.322068 4.36719 1.44707 2.39844 3.32207 1.32031C5.17363 0.242188 7.44707 0.242188 9.32207 1.32031C11.1736 2.39844 12.3221 4.36719 12.3221 6.5C12.3221 8.65625 11.1736 10.625 9.32207 11.7031C7.44707 12.7812 5.17363 12.7812 3.32207 11.7031C1.44707 10.625 0.322068 8.65625 0.322068 6.5ZM6.32207 8.375C6.97832 8.375 7.58769 8.02344 7.93926 7.4375C8.26738 6.875 8.26738 6.14844 7.93926 5.5625C7.58769 5 6.97832 4.625 6.32207 4.625C5.64238 4.625 5.03301 5 4.68144 5.5625C4.35332 6.14844 4.35332 6.875 4.68144 7.4375C5.03301 8.02344 5.64238 8.375 6.32207 8.375ZM6.32207 3.125C7.51738 3.125 8.61894 3.78125 9.22832 4.8125C9.83769 5.86719 9.83769 7.15625 9.22832 8.1875C8.61894 9.24219 7.51738 9.875 6.32207 9.875C5.10332 9.875 4.00176 9.24219 3.39238 8.1875C2.78301 7.15625 2.78301 5.86719 3.39238 4.8125C4.00176 3.78125 5.10332 3.125 6.32207 3.125ZM5.57207 6.5C5.57207 6.10156 5.90019 5.75 6.32207 5.75C6.72051 5.75 7.07207 6.10156 7.07207 6.5C7.07207 6.92188 6.72051 7.25 6.32207 7.25C5.90019 7.25 5.57207 6.92188 5.57207 6.5Z"
                                fill="white"
                            ></path>
                        </svg>
                    </div>
                </div>
            )}
        >
            <Panel
                header={<div className="font-700">{sectionName || 'Opthal All Tables'}</div>}
                key="1"
            >
                <p className="mr-16 space-y-2">
                    <div className="flex items-center justify-between">
                        <div>Heading</div>{' '}
                        <div className="flex space-x-12">
                            <input
                                type="color"
                                id="head"
                                name="head"
                                value={rxConfig?.opthal_heading_color || '#2188FF'}
                                onChange={(e) => {
                                    saveRxConfigInState({
                                        opthal_heading_color: e.target.value,
                                    });
                                }}
                                className="circular-color-input"
                            />

                            <AntTooltip content="Reset">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                    onClick={() => {
                                        saveRxConfigInState({
                                            opthal_heading_color: '',
                                        });
                                    }}
                                >
                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                </svg>
                            </AntTooltip>
                        </div>
                    </div>
                    <div className="border-b border-darwin-neutral-200 mx-8"></div>
                    <div className="flex items-center justify-between">
                        <div>Table title background color:</div>{' '}
                        <div className="flex space-x-12">
                            <input
                                type="color"
                                id="head"
                                name="head"
                                value={rxConfig?.opthal_table_heading_color || '#E4DEEB'}
                                onChange={(e) => {
                                    saveRxConfigInState({
                                        opthal_table_heading_color: e.target.value,
                                    });
                                }}
                                className="circular-color-input"
                            />

                            <AntTooltip content="Reset">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                    onClick={() => {
                                        saveRxConfigInState({
                                            opthal_table_heading_color: '',
                                        });
                                    }}
                                >
                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                </svg>
                            </AntTooltip>
                        </div>
                    </div>
                    <div className="flex items-center justify-between">
                        <div>Table border color:</div>{' '}
                        <div className="flex space-x-12">
                            <input
                                type="color"
                                id="head"
                                name="head"
                                value={rxConfig?.opthal_table_border_color || '#8064A2'}
                                onChange={(e) => {
                                    saveRxConfigInState({
                                        opthal_table_border_color: e.target.value,
                                    });
                                }}
                                className="circular-color-input"
                            />

                            <AntTooltip content="Reset">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                    onClick={() => {
                                        saveRxConfigInState({
                                            opthal_table_border_color: '',
                                        });
                                    }}
                                >
                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                </svg>
                            </AntTooltip>
                        </div>
                    </div>
                </p>
            </Panel>
        </Collapse>
    );
};

export default OpthalAllTables;
